import { createContext, useContext, useEffect, useReducer, useState } from 'react';
import ajaxConfig from '../util/remote/ajaxConfig';
import ajaxMark from '../util/remote/ajaxMark';
import { useTheme } from './ThemeContext';
import Notification from '../components/Common/Notification';
import ajaxStaff from '../util/remote/ajaxStaff';

const initialState = { 
   paperListing: null,
   organisedMarks: null,
   classRoom: null,
   stream: null,
   paper: null,
   loadingOrganizer: false,
   entryClass: null,
   entryStream: null,
   entryPaper: null,
   marksForm: null,
   loadingMarksForm: false,
   marksEntryLoad: null,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
};


const MarksContext = createContext();

export const MarksProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const { setNotify } = useTheme();
  const [copyMarks, setCopyMarks] = useState({ show: false, data: null, callback: null });

  const getSubjectPapers = async (refresh = false) => {
    const server_response = await ajaxConfig.getAllSubjectPapers();
    if (server_response.status === "OK") {
      dispatch({ type: "paperListing", payload: server_response.details });
    } else {
      dispatch({ type: "paperListing", payload: '404' });
    }
   
  };

  const setPaper = (paper) => {
    dispatch({ type: "paper", payload: paper });
  };

  const setClass = (classData) => {
    dispatch({ type: "classRoom", payload: classData });
  }
  const setStream = (streamData) => {
    dispatch({ type: "stream", payload: streamData });
  }

  const setEntryClass = (classData) => {
    dispatch({ type: "entryClass", payload: classData });
  }
  const setEntryStream = (streamData) => {
    dispatch({ type: "entryStream", payload: streamData });
  }
  const setEntryPaper = (paperData) => {
    dispatch({ type: "entryPaper", payload: paperData });
  }

  

  const getOrganisedMarks = async () => {
    dispatch({ type: "loadingOrganizer", payload: true });
    const server_response = await ajaxMark.getOrganiseMarksList(state.classRoom.class_id, state.paper.value, state.stream?.value);
    dispatch({ type: "loadingOrganizer", payload: false });
    if (server_response.status === "OK") {
      dispatch({ type: "organisedMarks", payload: server_response.details });
    } else {
      dispatch({ type: "organisedMarks", payload: '404' });
    }
  }

   const getMarksEntryForm=async()=>{
       
        const data={
            class_id:state.entryClass?.class_id || 0,
            paper_id:state.entryPaper?.value || 0,
            stream_id:state.entryStream?.value
        }
        dispatch({ type: "loadingMarksForm", payload: true });
        const server_response = await ajaxMark.getMarksEntrySheet(data);
        dispatch({ type: "loadingMarksForm", payload: false });
        if(server_response.status==="OK"){   
          dispatch({ type: "marksForm", payload: server_response.details });
        }else{
            dispatch({ type: "marksForm", payload: '404' });
            setNotify(<Notification type="danger" message={server_response.message} />);
        }
    }

    const getMarksEntryLoad = async () => {
      const server_response = await ajaxStaff.fetchMyMarksLoad();
      if (server_response.status === "OK") {
        dispatch({ type: "marksEntryLoad", payload: server_response.details });
      } else {
        dispatch({ type: "marksEntryLoad", payload: '404' });
      }
    }

  
  return(
    <MarksContext.Provider value={{
      ...state,
      copyMarks,
      dispatch,
      getSubjectPapers,
      setPaper,
      setClass,
      setStream,
      getOrganisedMarks,
      getMarksEntryForm,
      setEntryClass,
      setEntryStream,
      setEntryPaper,
      getMarksEntryLoad,
      setCopyMarks,
      }}>
      {children}
    </MarksContext.Provider>
  )

}

export const useMarks = ()=>useContext(MarksContext);

